export class ReportsConfigurationBase {
    attributes = { grouping: 'vehicle_parts' };
    company_id = crypto.randomUUID();
    smartphoto_id = crypto.randomUUID();
    createdAt = 1;
    reports = [{
            uuid: crypto.randomUUID(),
            is_main_report: true,
            damages: [],
            report_type: 'user'
        }];
    version = '';
    constructor(base = {}) {
        Object.entries(base).forEach(([key, value]) => {
            this[key] = value ?? this[key];
        });
    }
}
